(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csl-pet-home"] && !Shopify.designMode) return;
  try {
    
function initCrazySmart(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 let pet='cane',filter='all';
 const offer=root.querySelector('[data-csi-offers]');
 const status=root.querySelector('[data-csi-status]');
 function update(){
  root.querySelectorAll("[data-cxd-paths]").forEach(p=>p.hidden=p.dataset.cxdPaths!==pet);
  root.dataset.pet=pet;
  root.querySelectorAll('[data-csi-pet]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.csiPet===pet)));
  root.querySelectorAll('[data-csi-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.csiFilter===filter)));
  let count=0;
  root.querySelectorAll('[data-csi-panel]').forEach(panel=>{
   const active=panel.dataset.csiPanel===pet+'-'+filter;panel.hidden=!active;if(!active)return;
   panel.querySelectorAll('[data-csi-sale]').forEach(card=>{const matches=!offer.checked||card.dataset.csiSale==='true';card.hidden=!matches||count>=8;if(matches)count++});
   panel.querySelector('[data-csi-empty]').hidden=count>0;
  });
  const petName=root.querySelector('[data-csi-pet][aria-pressed=true]').textContent.replace('↗','').trim();
  const filterName=root.querySelector('[data-csi-filter][aria-pressed=true]').textContent.trim();
  status.textContent=petName+' · '+filterName+' · '+Math.min(count,8);
 }
 root.querySelectorAll('[data-csi-pet]').forEach(b=>b.addEventListener('click',()=>{pet=b.dataset.csiPet;update()}));
 root.querySelectorAll('[data-csi-filter]').forEach(b=>b.addEventListener('click',()=>{filter=b.dataset.csiFilter;update()}));
 offer.addEventListener('change',update);update();
}
document.querySelectorAll('[data-csi]').forEach(initCrazySmart);
document.querySelectorAll('[data-csv-film]').forEach(video=>{
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(entry.isIntersecting&&!reduced&&video.muted){video.play().catch(()=>{});}else if(!entry.isIntersecting){video.pause();}}),{threshold:.4});observer.observe(video);}
});
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-csi]').forEach(initCrazySmart));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
